import { styled } from "../../../../../../styles";

export const Container = styled("div", {
  width: "100%",
  height: "100%",

  padding: "16px 46px 16px 46px",
});

export const Row = styled("div", {
  height: "28px",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",

  marginBottom: "16px",

  p: {
    width: "260px",

    color: "$gray-80",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "28px",
  },

  ".ant-checkbox-wrapper": {
    lineHeight: "0px !important",
  },

  ".ant-checkbox .ant-checkbox-inner": {
    width: "18px !important",
    height: "18px !important",
    borderWidth: "2px !important",

    "&::after": {
      borderWidth: "2px !important",
    },
  },

  variants: {
    disabled: {
      true: {
        label: {
          opacity: "0.5",
        },
      },
    },
  },
});

export const ColumnTitle = styled("p", {
  width: "260px",

  color: "$charcoal !important",
  fontSize: "14px",
  lineHeight: "22px !important",
});

export const Title = styled("p", {
  fontSize: "16px",
  fontWeight: "600",
  fontFamily: "$openSans",
  lineHeight: "22px",
  color: "$black",
});

export const Subtitle = styled("p", {
  fontSize: "14px",
  fontWeight: "500",
  fontFamily: "$openSans",
  lineHeight: "22px",
  color: "$gray-80",
  maxWidth: "334px",
  margin: "15px 0",

  variants: {
    larger: {
      true: {
        maxWidth: "405px",
      },
    },
  },
});

export const SubmitContainer = styled("div", {
  height: "70px",
  display: "flex",
  gap: "40px",
  padding: "26px 12px 0px 0px",
  alignItems: "center",
});

export const CancelButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "5px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },

  variants: {
    isModal: {
      true: {
        padding: "0 $10",
      },
    },
  },
});
